import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import Footer from "../../../Components/Footer/footer";
import StepRoutes from "../../../Routes/steps_routes";
import { FcCamcorder, FcCamcorderPro, FcCollaboration } from "react-icons/fc";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import axios from "axios";
import { MediaTaskAssign } from "../../../SchemaInfo/info";
import { MediaAssignTaskSchema } from "../../../Schemas/Media And Marketing/mediaDelivery.schema";
import { useParams } from "react-router";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const EditMarketingDeliveryTask = () => {
  let { id } = useParams();
  const [agencies, setAgencies] = useState([]);
  const [taskAssign, setTaskAssign] = useState(MediaTaskAssign);
  const [loadingAgencies, setLoadingAgencies] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/mediaDelivery/get-task/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setTaskAssign({ ...res.data, imageDelete: [], videoDelete: [] });
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting Lead!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  // =========================================================
  // GET AGENCY LIST
  // =========================================================

  const getAgencyList = async () => {
    try {
      setLoadingAgencies(true);

      const response = await performRequest(
        "GET",
        "/mediaDelivery/get-agencies"
      );

      console.log("Agency response:", response);

      if (response?.status === 200 || response?.status === 201) {
        setAgencies(response?.data?.data || []);
      }
    } catch (error) {
      console.error("Get agency error:", error);

      Toast("error", "Failed to fetch agency list");
    } finally {
      setLoadingAgencies(false);
    }
  };

  useEffect(() => {
    getAgencyList();
  }, []);

  // =========================================================
  // IMAGE CHANGE
  // =========================================================

  const handleImageChange = (event, values, setFieldValue) => {
    const files = Array.from(event.target.files || []);

    if (!files.length) {
      return;
    }

    const updatedFiles = [...(values.rawImages || []), ...files];

    setFieldValue("rawImages", updatedFiles);

    // Allow selecting same file again
    event.target.value = "";
  };

  // =========================================================
  // VIDEO CHANGE
  // =========================================================

  const handleVideoChange = (event, values, setFieldValue) => {
    const files = Array.from(event.target.files || []);

    if (!files.length) {
      return;
    }

    const updatedFiles = [...(values.rawVideos || []), ...files];

    setFieldValue("rawVideos", updatedFiles);

    // Allow selecting same file again
    event.target.value = "";
  };

  // =========================================================
  // REMOVE IMAGE
  // =========================================================

  const removeImage = (index, values, setFieldValue) => {
    const image = values.rawImages?.[index];

    if (!image) return;

    // If existing GCP image
    if (image.url && !image.file) {
      setFieldValue("imageDelete", [...(values.imageDelete || []), image.url]);
    }

    // Remove from current images
    const updatedImages = values.rawImages.filter(
      (_, fileIndex) => fileIndex !== index
    );

    setFieldValue("rawImages", updatedImages);
  };

  // =========================================================
  // REMOVE VIDEO
  // =========================================================

  const removeVideo = (index, values, setFieldValue) => {
    const video = values.rawVideos?.[index];

    if (!video) return;

    // If existing GCP video
    if (video.url && !video.file) {
      setFieldValue("videoDelete", [...(values.videoDelete || []), video.url]);
    }

    // Remove from current videos
    const updatedVideos = values.rawVideos.filter(
      (_, fileIndex) => fileIndex !== index
    );

    setFieldValue("rawVideos", updatedVideos);
  };

  // =========================================================
  // ADD LINK
  // =========================================================

  const addLink = (values, setFieldValue) => {
    setFieldValue("links", [
      ...(values.links || []),
      {
        title: "",
        url: "",
      },
    ]);
  };

  // =========================================================
  // REMOVE LINK
  // =========================================================

  const removeLink = (index, values, setFieldValue) => {
    const updatedLinks = values.links.filter(
      (_, linkIndex) => linkIndex !== index
    );

    setFieldValue("links", updatedLinks);
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      setSubmitting(true);
  
      let uploadedImages = [];
      let uploadedVideos = [];
      let uploadedSubmittedWork = [];
  
      // =====================================================
      // 1. EXISTING IMAGES
      // =====================================================
  
      const existingImages = (values.rawImages || []).filter(
        (file) => file?.url && !(file instanceof File)
      );
  
      const newImageFiles = (values.rawImages || []).filter(
        (file) => file instanceof File
      );
  
      // =====================================================
      // 2. EXISTING VIDEOS
      // =====================================================
  
      const existingVideos = (values.rawVideos || []).filter(
        (file) => file?.url && !(file instanceof File)
      );
  
      const newVideoFiles = (values.rawVideos || []).filter(
        (file) => file instanceof File
      );
  
      // =====================================================
      // 3. UPLOAD NEW IMAGES
      // =====================================================
  
      for (const file of newImageFiles) {
        const signedRes = await performRequest(
          "POST",
          "/postPlanning/generateUploadUrl",
          {
            fileName: file.name,
            contentType: file.type,
            fileType: "image",
          }
        );
  
        await axios.put(
          signedRes.data.uploadUrl,
          file,
          {
            headers: {
              "Content-Type": file.type,
            },
          }
        );
  
        uploadedImages.push({
          fileName: file.name,
          fileType: file.type,
          url: encodeURI(
            signedRes.data.publicUrl
          ),
        });
      }
  
      // =====================================================
      // 4. UPLOAD NEW VIDEOS
      // =====================================================
  
      for (const file of newVideoFiles) {
        const signedRes = await performRequest(
          "POST",
          "/postPlanning/generateUploadUrl",
          {
            fileName: file.name,
            contentType: file.type,
            fileType: "video",
          }
        );
  
        await axios.put(
          signedRes.data.uploadUrl,
          file,
          {
            headers: {
              "Content-Type": file.type,
            },
          }
        );
  
        uploadedVideos.push({
          fileName: file.name,
          fileType: file.type,
          url: encodeURI(
            signedRes.data.publicUrl
          ),
        });
      }
  
      // =====================================================
      // 5. FINAL IMAGE ARRAY
      // =====================================================
  
      const finalImages = [
        ...existingImages,
        ...uploadedImages,
      ];
  
      // =====================================================
      // 6. FINAL VIDEO ARRAY
      // =====================================================
  
      const finalVideos = [
        ...existingVideos,
        ...uploadedVideos,
      ];
  
      // =====================================================
      // 7. SELECTED AGENCY
      // =====================================================
  
      const selectedAgency = agencies.find(
        (agency) =>
          String(agency.id) ===
          String(values.agencyId)
      );
  
      // =====================================================
      // 8. FILTER LINKS
      // =====================================================
  
      const filteredLinks = (
        values.links || []
      ).filter(
        (link) =>
          link?.title?.trim() ||
          link?.url?.trim()
      );
  
      // =====================================================
      // 9. SUBMITTED WORK
      //     IMAGES + VIDEOS IN SAME ARRAY
      // =====================================================
  
      for (
        const file of values.submittedWork || []
      ) {
        // ---------------------------------------------
        // Existing URL
        // ---------------------------------------------
  
        if (typeof file === "string") {
          uploadedSubmittedWork.push(
            encodeURI(file)
          );
  
          continue;
        }
  
        // ---------------------------------------------
        // Existing object
        // ---------------------------------------------
  
        if (
          file?.url &&
          !(file instanceof File)
        ) {
          uploadedSubmittedWork.push(
            encodeURI(file.url)
          );
  
          continue;
        }
  
        // ---------------------------------------------
        // New File
        // ---------------------------------------------
  
        if (file instanceof File) {
          const isVideo =
            file.type.startsWith("video/");
  
          const signedRes =
            await performRequest(
              "POST",
              "/postPlanning/generateUploadUrl",
              {
                fileName: file.name,
                contentType: file.type,
                fileType: isVideo
                  ? "video"
                  : "image",
              }
            );
  
          await axios.put(
            signedRes.data.uploadUrl,
            file,
            {
              headers: {
                "Content-Type": file.type,
              },
            }
          );
  
          uploadedSubmittedWork.push(
            encodeURI(
              signedRes.data.publicUrl
            )
          );
        }
      }
  
      // =====================================================
      // 10. FINAL PAYLOAD
      // =====================================================
  
      const payload = {
        taskName:
          values.taskName,
  
        brandAsset:
          values.brandAsset,
  
        taskDescription:
          values.taskDescription,
  
        agencyId:
          Number(values.agencyId),
  
        agencyName:
          selectedAgency?.userName || "",
  
        // Images
        rawImages:
          finalImages,
  
        // Videos
        rawVideos:
          finalVideos,
  
        // Reference links
        links:
          filteredLinks,
  
        instructions:
          values.instructions || "",
  
        deadline:
          values.deadline,
  
        // Images + Videos
        submittedWork:
          uploadedSubmittedWork,
  
        submittedWorkDelete:
          values.submittedWorkDelete || [],
  
        // Google Drive
        submittedDriveLinks: (
          values.submittedDriveLinks || []
        ).filter(
          (link) => link?.trim()
        ),
  
        imageDelete:
          values.imageDelete || [],
  
        videoDelete:
          values.videoDelete || [],
      };
  
      console.log(
        "UPDATE TASK PAYLOAD =>",
        payload
      );
  
      // =====================================================
      // 11. UPDATE API
      // =====================================================
  
      const response =
        await performRequest(
          "PATCH",
          `/mediaDelivery/updateAssignTask/${id}`,
          payload
        );
  
      if (response?.status === 200) {
        Toast(
          "success",
          "Task updated successfully"
        );
  
        resetForm();
  
        navigate(
          `/media-task-view/${id}`
        );
      }
    } catch (error) {
      console.log(
        "Update task error =>",
        error
      );
  
      console.log(
        "Update error response =>",
        error?.response?.data
      );
  
      Toast(
        "error",
        "Failed to update task"
      );
    } finally {
      setSubmitting(false);
    }
  };

  // =========================================================
  // SUBMITTED WORK - IMAGES + VIDEOS
  // =========================================================

  const handleSubmittedWorkChange = (event, values, setFieldValue) => {
    const files = Array.from(event.target.files || []);

    if (!files.length) return;

    setFieldValue("submittedWork", [...(values.submittedWork || []), ...files]);

    event.target.value = "";
  };

  // =========================================================
  // REMOVE SUBMITTED WORK
  // =========================================================

  const removeSubmittedWork = (index, values, setFieldValue) => {
    const work = values.submittedWork?.[index];

    if (!work) return;

    // If existing GCP submitted work
    if (
      typeof work === "string" &&
      work.startsWith("https://storage.googleapis.com/")
    ) {
      setFieldValue("submittedWorkDelete", [
        ...(values.submittedWorkDelete || []),
        work,
      ]);
    }

    // Remove from current submitted work
    const updatedWork = values.submittedWork.filter(
      (_, fileIndex) => fileIndex !== index
    );

    setFieldValue("submittedWork", updatedWork);
  };

  // =========================================================
  // ADD SUBMITTED DRIVE LINK
  // =========================================================

  const addSubmittedDriveLink = (values, setFieldValue) => {
    setFieldValue("submittedDriveLinks", [
      ...(values.submittedDriveLinks || []),
      "",
    ]);
  };

  // =========================================================
  // REMOVE SUBMITTED DRIVE LINK
  // =========================================================

  const removeSubmittedDriveLink = (index, values, setFieldValue) => {
    const updatedLinks = (values.submittedDriveLinks || []).filter(
      (_, linkIndex) => linkIndex !== index
    );

    setFieldValue("submittedDriveLinks", updatedLinks);
  };

  if (loading) {
    <LoadingPage></LoadingPage>;
  }
  return (
    <div className="container-fluid">
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    <FcCamcorderPro></FcCamcorderPro> Marketing Delivery
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
            <div className="card">
              {/* =================================================
            HEADER
        ================================================= */}

              <div className="card-header">
                <h3 className="card-title">Edit & Assign Marketing Task</h3>
              </div>

              {/* =================================================
            FORMIK
        ================================================= */}

              <Formik
                initialValues={taskAssign}
                validationSchema={MediaAssignTaskSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
              >
                {({ values, errors, touched, setFieldValue, isSubmitting }) => (
                  <Form>
                    <div className="card-body">
                      {/* =================================================
                    TASK DETAILS
                ================================================= */}

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Task Name
                        </label>

                        {
                          <div className="w-100 col">
                            <CustomInput
                              name="taskName"
                              placeholder="Enter task name"
                              required
                              disabled={
                                process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                                store?.Role
                              }
                            />
                            {touched.taskName && errors.taskName && (
                              <div className="text-danger mt-1">
                                {errors.taskName}
                              </div>
                            )}
                          </div>
                        }
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Branding Assets
                        </label>
                        <div className="w-100 col">
                          <CustomSelect
                            name="brandAsset"
                            className="form-control"
                            disabled={
                              process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                              store?.Role
                            }
                          >
                            <option value="">Select</option>
                            <option value="Kryzen Biotech">
                              Kryzen Biotech{" "}
                            </option>
                            <option value="Hydroponic Masterclass">
                              Hydroponic Masterclass
                            </option>
                            <option value="Sudhir Devkar">Sudhir Devkar</option>
                            <option value="Eat Pure Greens">
                              Eat Pure Greens
                            </option>
                          </CustomSelect>

                          {touched.brandAsset && errors.brandAsset && (
                            <p className="text-danger">
                              {" "}
                              {errors.brandAsset}{" "}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="row mb-3">
                        <label className="form-label col-3">
                          Assign Agency
                        </label>

                        <div className="col-9">
                          <select
                            className="form-select"
                            name="agencyId"
                            value={values.agencyId || ""}
                            onChange={(e) => {
                              const agencyId = e.target.value;

                              const selectedAgency = agencies.find(
                                (agency) =>
                                  String(agency.id) === String(agencyId)
                              );

                              setFieldValue("agencyId", agencyId);

                              setFieldValue(
                                "agencyName",
                                selectedAgency?.userName || ""
                              );
                            }}
                            disabled={
                              process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                              store?.Role
                            }
                          >
                            <option value="">Select Agency</option>

                            {agencies?.map((agency) => (
                              <option key={agency.id} value={agency.id}>
                                {agency.userName}
                              </option>
                            ))}
                          </select>

                          {touched.agencyId && errors.agencyId && (
                            <div className="text-danger mt-1">
                              {errors.agencyId}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* =================================================
                    TASK DESCRIPTION
                ================================================= */}

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                        Task Description
                        </label>
                        <div className="w-100 col">
                          <CustomTextArea
                            label="Task Description"
                            name="taskDescription"
                            placeholder="Enter task description"
                            rows={4}
                            required
                            disabled={
                              process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                              store?.Role
                            }
                          />

                          {touched.taskDescription &&
                            errors.taskDescription && (
                              <div className="text-danger mt-1">
                                {errors.taskDescription}
                              </div>
                            )}
                        </div>
                      </div>

                      {/* =================================================
                    DEADLINE
                ================================================= */}

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Deadline
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            label="Deadline"
                            name="deadline"
                            type="date"
                            required
                            disabled={
                              process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                              store?.Role
                            }
                          />

                          {touched.deadline && errors.deadline && (
                            <div className="text-danger mt-1">
                              {errors.deadline}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* =================================================
                    RAW IMAGES
                ================================================= */}

                      <div className="mb-4 row">
                        <label className="w-25 form-label col-3">
                          Raw Images
                        </label>
                        <div className="w-100 col">
                          <input
                            type="file"
                            className="form-control"
                            multiple
                            accept="image/*"
                            onChange={(event) =>
                              handleImageChange(event, values, setFieldValue)
                            }
                            disabled={
                              process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                              store?.Role
                            }
                          />

                          {values.rawImages?.length > 0 && (
                            <div className="mt-3">
                              <div className="fw-bold mb-2">
                                Selected Images ({values.rawImages.length})
                              </div>

                              {values.rawImages?.map((file, index) => {
                                const imageUrl =
                                  file instanceof File
                                    ? URL.createObjectURL(file)
                                    : file?.url;

                                return (
                                  <div
                                    key={index}
                                    className="d-inline-block position-relative me-3 mb-3"
                                  >
                                    <img
                                      src={imageUrl}
                                      alt="preview"
                                      style={{
                                        width: "120px",
                                        height: "120px",
                                        objectFit: "cover",
                                        borderRadius: "8px",
                                        border: "1px solid #ddd",
                                      }}
                                    />

                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger position-absolute"
                                      style={{
                                        top: "5px",
                                        right: "5px",
                                      }}
                                      onClick={() =>
                                        removeImage(
                                          index,
                                          values,
                                          setFieldValue
                                        )
                                      }
                                    >
                                      ×
                                    </button>
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* =================================================
                    RAW VIDEOS
                ================================================= */}

                      <div className="mb-4 row">
                        <label className="w-25 form-label col-3">
                          Raw Videos
                        </label>
                        <div className="w-100 col">
                          <input
                            type="file"
                            className="form-control"
                            multiple
                            accept="video/*"
                            onChange={(event) =>
                              handleVideoChange(event, values, setFieldValue)
                            }
                            disabled={
                              process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                              store?.Role
                            }
                          />

                          {values.rawVideos?.map((file, index) => {
                            const videoUrl =
                              file instanceof File
                                ? URL.createObjectURL(file)
                                : file?.url;

                            return (
                              <div
                                key={index}
                                className="d-inline-block position-relative me-3 mb-3 mt-3"
                              >
                                <video
                                  src={videoUrl}
                                  controls
                                  style={{
                                    width: "180px",
                                    height: "120px",
                                    objectFit: "cover",
                                    borderRadius: "8px",
                                    border: "1px solid #ddd",
                                  }}
                                />

                                <button
                                  type="button"
                                  className="btn btn-sm btn-danger position-absolute"
                                  style={{
                                    top: "5px",
                                    right: "5px",
                                  }}
                                  onClick={() =>
                                    removeVideo(index, values, setFieldValue)
                                  }
                                >
                                  ×
                                </button>
                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Instruction
                        </label>
                        <div className="w-100 col">
                          <CustomTextArea
                            label="Additional Instructions"
                            name="instructions"
                            placeholder="Enter additional instructions for the agency"
                            rows={5}
                            disabled={
                              process.env.REACT_APP_ROLE_MARKETING_AGENCY ===
                              store?.Role
                            }
                          />
                        </div>
                      </div>

                      {/* =================================================
                    REFERENCE LINKS
                ================================================= */}

                      <div className="mb-4 row">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <label className="w-25 form-label col-3">
                            Reference Links
                          </label>

                          <button
                            type="button"
                            className="btn btn-sm btn-primary"
                            onClick={() => addLink(values, setFieldValue)}
                          >
                            + Add Link
                          </button>
                        </div>
                        <div className="mb-1 row">
                          <label className="w-25 form-label col-3"></label>
                          <div className="w-100 col">
                            {values.links.map((link, index) => (
                              <div
                                className="border rounded p-3 mb-3"
                                key={index}
                              >
                                <div className="row">
                                  {/* LINK TITLE */}

                                  <div className="col-md-5">
                                    <CustomInput
                                      label="Link Title"
                                      name={`links[${index}].title`}
                                      placeholder="Enter link title"
                                      disabled={
                                        process.env
                                          .REACT_APP_ROLE_MARKETING_AGENCY ===
                                        store?.Role
                                      }
                                    />
                                  </div>

                                  {/* LINK URL */}

                                  <div className="col-md-5">
                                    <CustomInput
                                      label="URL"
                                      name={`links[${index}].url`}
                                      placeholder="https://..."
                                      disabled={
                                        process.env
                                          .REACT_APP_ROLE_MARKETING_AGENCY ===
                                        store?.Role
                                      }
                                    />
                                  </div>

                                  {/* REMOVE */}

                                  <div className="col-md-2 d-flex align-items-end mb-3">
                                    {values.links.length > 1 && (
                                      <button
                                        type="button"
                                        className="btn btn-danger w-100"
                                        onClick={() =>
                                          removeLink(
                                            index,
                                            values,
                                            setFieldValue
                                          )
                                        }
                                      >
                                        Remove
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* =================================================
                            SUBMITTED FINAL WORK
                          ================================================= */}
                      <hr></hr>
                      <h3> SUBMITTED FINAL WORK</h3>
                      <hr></hr>
                      <div className="mb-4 row">
                        <label className="w-25 form-label col-3">
                          Submitted Work
                        </label>

                        <div className="w-100 col">
                          <input
                            type="file"
                            className="form-control"
                            multiple
                            accept="image/*,video/*"
                            onChange={(event) =>
                              handleSubmittedWorkChange(
                                event,
                                values,
                                setFieldValue
                              )
                            }
                          />

                          <small className="text-muted">
                            Upload final images and videos
                          </small>

                          {values.submittedWork?.length > 0 && (
                            <div className="mt-3">
                              <div className="fw-bold mb-2">
                                Submitted Work ({values.submittedWork.length})
                              </div>

                              <div className="d-flex flex-wrap">
                                {values.submittedWork.map((file, index) => {
                                  const fileUrl =
                                    file instanceof File
                                      ? URL.createObjectURL(file)
                                      : typeof file === "string"
                                      ? file
                                      : file?.url;

                                  const isVideo =
                                    file instanceof File
                                      ? file.type.startsWith("video/")
                                      : /\.(mp4|mov|avi|webm|mkv)$/i.test(
                                          fileUrl || ""
                                        );

                                  return (
                                    <div
                                      key={index}
                                      className="position-relative me-3 mb-3"
                                    >
                                      {isVideo ? (
                                        <video
                                          src={fileUrl}
                                          controls
                                          style={{
                                            width: "180px",
                                            height: "120px",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                            border: "1px solid #ddd",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={fileUrl}
                                          alt="submitted"
                                          style={{
                                            width: "120px",
                                            height: "120px",
                                            objectFit: "cover",
                                            borderRadius: "8px",
                                            border: "1px solid #ddd",
                                          }}
                                        />
                                      )}

                                      <button
                                        type="button"
                                        className="btn btn-sm btn-danger position-absolute"
                                        style={{
                                          top: "5px",
                                          right: "5px",
                                        }}
                                        onClick={() =>
                                          removeSubmittedWork(
                                            index,
                                            values,
                                            setFieldValue
                                          )
                                        }
                                      >
                                        ×
                                      </button>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* =================================================
    SUBMITTED GOOGLE DRIVE LINKS
================================================= */}

                      <div className="mb-4 row">
                        <label className="w-25 form-label col-3">
                          Submitted Drive Links
                        </label>

                        <div className="w-100 col">
                          {(values.submittedDriveLinks || []).map(
                            (link, index) => (
                              <div className="row mb-3" key={index}>
                                <div className="col-md-10">
                                  <CustomInput
                                    label={`Drive Link ${index + 1}`}
                                    name={`submittedDriveLinks[${index}]`}
                                    placeholder="https://drive.google.com/..."
                                  />
                                </div>

                                <div className="col-md-2 d-flex align-items-end">
                                  <button
                                    type="button"
                                    className="btn btn-danger w-100"
                                    onClick={() =>
                                      removeSubmittedDriveLink(
                                        index,
                                        values,
                                        setFieldValue
                                      )
                                    }
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            )
                          )}

                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() =>
                              addSubmittedDriveLink(values, setFieldValue)
                            }
                          >
                            + Add Drive Link
                          </button>
                        </div>
                      </div>

                      {/* =================================================
                    SELECTED AGENCY SUMMARY
                ================================================= */}

                      {values.agencyId && (
                        <div className="alert alert-info mt-4">
                          <strong>Task will be assigned to:</strong>

                          <div className="mt-1">{values.agencyName}</div>
                        </div>
                      )}
                    </div>

                    {/* =================================================
                  FOOTER
              ================================================= */}

                    <div className="card-footer d-flex justify-content-end gap-2">
                      {/* <SimpleButton
                  type="button"
                  text="Cancel"
                /> */}

                      {/* <FormSubmitButton
                  type="submit"
                  text="Create & Assign Task"
                  loading={isSubmitting}
                  disabled={isSubmitting}
                /> */}
                      <SimpleButton buttonText="Cancel" type="secondary" />
                      <FormSubmitButton
                        buttonText="submit"
                        loading={isSubmitting}
                        disabled={isSubmitting}
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default EditMarketingDeliveryTask;
